<template>
  <div class="bespread-wrap module-layer1">
    <div class="screen-container">
      <div class="embed-responsive-16by9 videobox">
        <!-- <video loop muted autoplay class="video-background">
                        <source src="https://resource-mp4.ujoygames.com/pixel/pv_0523.mp4" type="video/mp4" />
                    </video> -->
      </div>
      <div class="kv-content">
        <div class="kv-play-btn" @click="showVideo"></div>
        <div class="kv-slogan">
          <!-- <img src="" alt="" srcset=""> -->
          <img
            :src="
              require('../../assets/img/layer1/slogn/slogn-' + lang + '.png')
            "
            alt=""
            srcset=""
          />
        </div>

        <div class="b-position">
          <div class="page-channel-list">
            <div class="page-channel-item ios-icon">
              <img
                :src="
                  require('../../assets/img/layer1/ios/ios-' +
                    lang +
                    '-btn.png')
                "
                alt=""
                srcset=""
                @click="AS_reg('ios')"
              />
            </div>
            <div class="page-channel-item gp-icon">
              <img
                :src="
                  require('../../assets/img/layer1/gg/gg-' + lang + '-btn.png')
                "
                alt=""
                srcset=""
                @click="GP_reg('gp')"
              />
            </div>
             <div class="page-channel-item pay-icon">
              <img
                :src="
                  require('../../assets/img/layer1/pay/pay-' + lang + '-btn.png')
                "
                alt=""
                srcset=""
                @click="pay_reg('pay')"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 首页视频 -->
      <video
        loop
        muted
        autoplay
        class="video-bg2 video-size"
        id="bgVideo"
        ref="bgVideo"
      >
        <source
          src="https://resource-mp4.ujoygames.com/sof/bg.mp4"
          type="video/mp4"
        />
      </video>
    </div>
  </div>
</template>
<script>
export default {
  name: "app",
  props: ["language"],

  data() {
    return {
      lang: localStorage.getItem("sof_locale") || "en"
    };
  },
  watch: {
    // 监听到父组件传递过来的数据后，加工一下，
    // 存到data中去，然后在页面上使用
    language(newVal, oldVal) {
      this.lang = newVal;
    }
  },
  created() {},
  methods: {
    showVideo() {
      this.$emit("handleVideo");
    },
    AS_reg(val) {
      this.common.goShare(val);
    },
    GP_reg(val) {
      this.common.goShare(val);
    },
    pay_reg(val) {
      this.common.goShare(val);

    }
  }
};
</script>
<style lang="scss" scoped>
.module-layer1 {
  // pointer-events: none;
  .videobox {
    position: relative;
    height: 100vh;
    /*进行视频裁剪*/
    overflow: hidden;

    .video-background {
      position: absolute;
      left: 50%;
      top: 50%;
      /*保证视频内容始终居中*/
      transform: translate(-50%, -50%);
      width: 100%;
      height: 100%;
      /*保证视频充满屏幕*/
      object-fit: cover;
      min-height: 800px;
    }
  }
  .screen-container {
    background-image: url("../../assets/img/layer1/bg.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    .kv-play-btn {
      background-image: url("../../assets/img/layer1/playbtn.png");
      background-size: 100% 100%;
      width: 128px;
      height: 128px;
    }
    .kv-content {
      position: absolute;
      bottom: 3.2vw;
      left: 50%;
      transform: translate(-50%, 0);
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      z-index: 1;

      .kv-slogan {
        // width: 733px;
        // height: 271px;
        width: 945px;
        height: auto;
        img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }

      .b-position {
        .page-channel-list {
          display: flex;
          align-items: end;
          justify-content: end;
          gap: 16px;

          .page-channel-item {
            cursor: pointer;
            width: auto;
            height: 85px;

            img {
              width: 100%;
              height: 100%;
            }
          }
          .pay-icon {
            height: 106px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1200px) {
  .module-layer1 {
    .kv-content {
      bottom: 8vw !important;
    }
  }
}

@media screen and (min-width: 2000px) and (max-width: 2561px) {
  .module-layer1 {
    .kv-content {
      bottom: 6vw !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/layer1.vue